// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"ff401e0ad15816aa6774","655":"85be8204c62e0d77ecd3"}[chunkId] + ".js";
};